import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

const MemberSignIn = () => {
  const [memberMobile, setMemberMobile] = useState("");
  const [memberDetails, setMemberDetails] = useState(null);
  const [isMobileSubmitted, setIsMobileSubmitted] = useState(false); // Tracks whether mobile number is submitted
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showTick, setShowTick] = useState(false);

  // Handle login action
  const handleContinue = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const url = `https://signinapi.heuristticminds.com/api/Member/SignIn-ValidateMemberMobile?MemberMobile=${memberMobile}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        setErrorMessage("Invalid Mobile Number !!");
        setMemberDetails(null);
        setLoading(false);
        return;
      }

      const apiData = await response.json();

      if (apiData && apiData.memberName) {
        setErrorMessage("");
        setMemberDetails(apiData); // Save API data in state
        setIsMobileSubmitted(true); // Proceed to details screen
      } else {
        setErrorMessage("Member not found!");
        setMemberDetails(null);
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage("An error occurred while fetching member details.");
      setMemberDetails(null);
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  // Handle member sign-in action
  //   const handleSignInClick = async () => {
  //     setLoading(true);
  //     setErrorMessage("");
  //     setSuccessMessage("");
  //     try {
  //       const response = await fetch(
  //         `https://signinapi.heuristticminds.com/api/Member/SignIn-MemberSignIn?UID=${memberDetails.uid}`,
  //         {
  //           method: "PUT",
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );

  //       if (response.ok) {
  //         setMemberDetails((prevDetails) => ({
  //           ...prevDetails,
  //           signInStatus: 1, // Update sign-in status
  //         }));
  //         setSuccessMessage("Sign-in successful!");
  //       } else {
  //         setErrorMessage("Failed to sign in. Please try again.");
  //       }
  //     } catch (error) {
  //       console.error("Sign-in error:", error);
  //       setErrorMessage("An error occurred during sign-in.");
  //     }

  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 2000);
  //   };
  const handleSignInClick = async () => {
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await fetch(
        `https://signinapi.heuristticminds.com/api/Member/SignIn-MemberSignIn?UID=${memberDetails.uid}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        setTimeout(() => {
          setLoading(false);
          setShowTick(true);
        }, 2000);

        // tick ka time SAME rahega
        setTimeout(() => {
          setShowTick(false);
          setMemberDetails((prev) => ({
            ...prev,
            signInStatus: 1,
          }));
        }, 2000 + 1200); // loader + tick time
      } else {
        setLoading(false);
        setErrorMessage("Failed to sign in. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      setErrorMessage("An error occurred during sign-in.");
    }
  };

  /* 
    useEffect(() => {
        handleSignInClick();
    }, [memberDetails.uid]); 

 */

  return (
    <>
      <header>
        <div className="logo1">
          <img src="images/mumbai fc.jpg" alt="mumbai fc logo" />
        </div>
        <div className="logo2">
          <img src="images/insol-india-logo.jpg" alt="insol india logo" />
        </div>
      </header>
      <section className="secbg">
        {/* <div className="loginbox"> */}
        <div className={`${!isMobileSubmitted ? "loginbox" : "userbox"}`}>
          {/* Loader */}
          {loading && (
            <div className="loader">
              <img src="images/spinner.svg" alt="loader" />
            </div>
          )}

          {!isMobileSubmitted ? (
            // Mobile number form
            <div>
              <div className="logintitle">
                <strong>
                  <b>
                     INSOL India
                    <br />
                    Mumbai Financiers Colloquium 2026
                  </b>
                  <br />
                  Please Log In To Mark Your Attendance
                </strong>
              </div>
              <form className="login_form" onSubmit={handleContinue}>
                <div className="row_input">
                  <span className="lbl1">
                    Registered Mobile No. or Email Id
                  </span>
                  <input
                    type="text"
                    value={memberMobile}
                    placeholder="Mobile No. or Email Id"
                    className="txt1"
                    onChange={(e) => setMemberMobile(e.target.value)}
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
                <button type="submit" className="btnlogin">
                  Continue..
                </button>

                {errorMessage && (
                  <div className="text-danger">{errorMessage}</div>
                )}
                {successMessage && (
                  <div className="text-success">{successMessage}</div>
                )}
              </form>
            </div>
          ) : (
            // Member details
            <div className="details">
              {/* Loader OR Transition Tick (same jagah) */}
              {(loading || showTick) && (
                <div className="loader">
                  <img
                    src={loading ? "images/spinner.svg" : "images/tick.svg"}
                    alt={loading ? "loader" : "tick"}
                    className={!loading ? "imgtick" : ""}
                  />
                </div>
              )}

              {/* FINAL DETAILS BOX */}
              {!loading && !showTick && (
                <>
                  {/* Tick on top of box (jaise pehle tha) */}
                  {memberDetails?.signInStatus === 1 && (
                    <img className="imgtick" src="images/tick.svg" alt="tick" />
                  )}

                  <h5 className="heading">
                    {memberDetails?.signInStatus === 1
                      ? "Welcome to Mumbai Financiers Colloquium 2026"
                      : "Welcome"}
                  </h5>

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "20px",
                      display: "block",
                    }}
                  >
                    <strong>{memberDetails?.memberName}</strong>
                  </p>

                  <p>
                    <strong>Badge ID:</strong> {memberDetails?.badgeID}
                  </p>

                  <p>
                    <strong>Mobile:</strong> {memberDetails?.mobile}
                  </p>

                  <p>
                    <strong>Email:</strong> {memberDetails?.eMail}
                  </p>

                  {memberDetails?.signInStatus === 1 ? (
                    <p className="text-success">
                      <strong>Status:</strong> Signed In
                    </p>
                  ) : (
                    <button
                      className="btnlogin"
                      onClick={handleSignInClick}
                      disabled={loading}
                    >
                      Click to Sign In
                    </button>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        <div className="copyright">
          © 2026 INSOL India | All rights reserved.
          <br />
          Developed By:{" "}
          <a href="https://heuristticminds.com/" target="_blank">
            Heuristtic Minds
          </a>
        </div>
      </section>
    </>
  );
};
export default MemberSignIn;
